export const sanitizeId = (id: string) => id.replace(/[^-0-9a-f]/g, '');
export const sanitizeString = (id: string) => id.replace(/[^-0-9a-zA-Z]/g, '');
